// extracted by mini-css-extract-plugin
module.exports = {"NavigationItems":"Navigation_NavigationItems__eQ6OA"};